import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@eduzz/houston-ui/Button';
import { getUnsubscribedProducers, subscribeToProducer } from 'services/notification';
import { UnsubscribedProducer } from 'interface/notifications';
import { useCallback, useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => ({
  action: {
    display: 'flex',
    flexDirection: 'row',
  },
  btn: {
    width: 190,
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(4, 0),
    borderBottom: `1px solid ${theme.palette.grey[600]}`,
  },
  itemDescription: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  },
  nameCourse: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  emptyState: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    '& > img': {
      margin: theme.spacing(8, 0),
      width: 212,
    },
    '& > .title': {
      fontSize: 20,
      fontWeight: 'bold',
      color: theme.palette.common.white,
      marginTop: 32,
    },
  },
}));

export const UnsubscribedProducerList = () => {
  const [loading, setLoading] = useState(false);
  const [producers, setProducers] = useState<UnsubscribedProducer[]>([]);
  const classes = useStyles();

  const subscribe = (producerId: number) => () => {
    subscribeToProducer(producerId).then(() => fetchUnsubscribedProducers());
  };

  const fetchUnsubscribedProducers = useCallback(() => {
    setLoading(true);
    getUnsubscribedProducers()
      .then(setProducers)
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchUnsubscribedProducers();
  }, [fetchUnsubscribedProducers]);

  if (producers.length === 0) {
    return null;
  }

  return (
    <Box marginY={12}>
      <Box marginBottom={4}>
        <Typography variant='h4' component='b'>
          Notificações desabilitadas via e-mail
        </Typography>
      </Box>

      <Box marginBottom={4}>
        <Typography variant='body1'>Habilite abaixo para voltar a receber as notificações via e-mail</Typography>
      </Box>

      {producers?.map((producer) => (
        <div className={classes.item}>
          <div className={classes.itemDescription}>
            <Typography variant='body1' component='b'>
              {producer.name}
            </Typography>
          </div>
          <div className={classes.action}>
            <Button
              disabled={loading}
              className={classes.btn}
              type='button'
              variant='outlined'
              onClick={subscribe(producer.id)}
            >
              Habilitar notificação
            </Button>
          </div>
        </div>
      ))}
    </Box>
  );
};
